document.addEventListener("DOMContentLoaded", function () {

  /* =========================================
     CAT AGE CALCULATOR
     ========================================= */

  const birthInput =
    document.getElementById("cat-birth-date");

  const calculateDateInput =
    document.getElementById("cat-current-date");

  const calculateButton =
    document.getElementById("cat-age-calculate");

  const results =
    document.getElementById("cat-age-results");

  const yearsOutput =
    document.getElementById("cat-years");

  const monthsOutput =
    document.getElementById("cat-months");

  const daysOutput =
    document.getElementById("cat-days");

  const humanAgeOutput =
    document.getElementById("human-age");

  const daysTogetherOutput =
    document.getElementById("days-together");

  const progressOutput =
    document.getElementById("life-progress");

  const progressBar =
    document.getElementById("life-progress-bar");


  /* =========================================
     Check Calculator Exists
     ========================================= */

  if (
    !birthInput ||
    !calculateDateInput ||
    !calculateButton
  ) {
    return;
  }


  /* =========================================
   Date Picker
   ========================================= */

function openDatePicker(input) {
  if (!input) {
    return;
  }

  try {
    if (typeof input.showPicker === "function") {
      input.showPicker();
    } else {
      input.focus();
    }
  } catch (error) {
    console.warn("Unable to open date picker:", error);
  }
}


/* -----------------------------------------
   Make Entire Date Field Clickable
   ----------------------------------------- */

const dateFields = document.querySelectorAll(
  ".cat-age-field"
  
);

document.querySelectorAll('.cat-age-field input[type="date"]').forEach(input => {
  input.addEventListener('selectstart', function (e) {
    e.preventDefault();
  });
});

dateFields.forEach(function (field) {

  const input = field.querySelector(
    'input[type="date"]'
  );

  if (!input) {
    return;
  }

  field.addEventListener("click", function () {
    openDatePicker(input);
  });

});


  /* =========================================
     Date Helpers
     ========================================= */

  function parseDate(value) {

    const parts =
      value.split("-");

    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }


  function formatDate(date) {

    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        date.getDate()
      ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }


  /* =========================================
     Default Calculation Date = Today
     ========================================= */

  const today =
    new Date();

  calculateDateInput.value =
    formatDate(today);


  /* =========================================
     Kitten Human Age Conversion
     ========================================= */

  function getKittenHumanAge(totalMonths) {

    /*
     * Approximate reference points used
     * by the Cat Age Calculator page:
     *
     * 1 month  ≈ 1 human year
     * 3 months ≈ 4 human years
     * 6 months ≈ 10 human years
     * 12 months ≈ 15 human years
     *
     * Values between reference points
     * are interpolated.
     */

    const milestones = [
      { months: 0, humanYears: 0 },
      { months: 1, humanYears: 1 },
      { months: 3, humanYears: 4 },
      { months: 6, humanYears: 10 },
      { months: 12, humanYears: 15 }
    ];


    /* -----------------------------------------
       Find Matching Range
       ----------------------------------------- */

    for (
      let i = 0;
      i < milestones.length - 1;
      i++
    ) {

      const current =
        milestones[i];

      const next =
        milestones[i + 1];


      if (
        totalMonths >= current.months &&
        totalMonths <= next.months
      ) {

        const monthRange =
          next.months -
          current.months;

        const humanAgeRange =
          next.humanYears -
          current.humanYears;

        const progress =
          (
            totalMonths -
            current.months
          ) /
          monthRange;

        return Math.round(
          current.humanYears +
          progress *
          humanAgeRange
        );
      }
    }


    /*
     * 12 months or older
     * should be handled by the
     * adult formula instead.
     */

    return 15;
  }


  /* =========================================
     Human Equivalent Age
     ========================================= */

  function calculateHumanAge(
    years,
    months
  ) {

    /*
     * Under 1 year:
     * use kitten conversion.
     */

    if (years === 0) {

      return getKittenHumanAge(
        months
      );
    }


    /*
     * 1 year = approximately 15
     * human years.
     */

    if (years === 1) {
      return 15;
    }


    /*
     * 2 years = approximately 24
     * human years.
     */

    if (years === 2) {
      return 24;
    }


    /*
     * After age 2:
     * each additional year ≈ 4 human years.
     */

    return (
      24 +
      (years - 2) * 4
    );
  }


  /* =========================================
     Calculate Age
     ========================================= */

  calculateButton.addEventListener(
    "click",
    function () {

      /* -----------------------------------------
         Check Dates
         ----------------------------------------- */

      if (
        !birthInput.value ||
        !calculateDateInput.value
      ) {

        alert(
          "Please enter both dates."
        );

        return;
      }


      const birthDate =
        parseDate(
          birthInput.value
        );

      const currentDate =
        parseDate(
          calculateDateInput.value
        );


      /* -----------------------------------------
         Validate Date
         ----------------------------------------- */

      if (
        birthDate > currentDate
      ) {

        alert(
          "The date of birth cannot be after the calculation date."
        );

        return;
      }


      /* =========================================
         Cat Age
         ========================================= */

      let years =
        currentDate.getFullYear() -
        birthDate.getFullYear();

      let months =
        currentDate.getMonth() -
        birthDate.getMonth();

      let days =
        currentDate.getDate() -
        birthDate.getDate();


      /* -----------------------------------------
         Adjust Days
         ----------------------------------------- */

      if (days < 0) {

        months--;

        const previousMonth =
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            0
          );

        days +=
          previousMonth.getDate();
      }


      /* -----------------------------------------
         Adjust Months
         ----------------------------------------- */

      if (months < 0) {

        years--;

        months += 12;
      }


      /* =========================================
         Display Cat Age
         ========================================= */

      yearsOutput.textContent =
        String(years).padStart(2, "0");

      monthsOutput.textContent =
        String(months).padStart(2, "0");

      daysOutput.textContent =
        String(days).padStart(2, "0");


      /* =========================================
         Human Equivalent Age
         ========================================= */

      const humanAge =
        calculateHumanAge(
          years,
          months
        );


      humanAgeOutput.textContent =
        humanAge;


      /* =========================================
         Time With You
         ========================================= */

      const millisecondsPerDay =
        1000 *
        60 *
        60 *
        24;


      const daysTogether =
        Math.floor(
          (
            currentDate -
            birthDate
          ) /
          millisecondsPerDay
        );


      daysTogetherOutput.textContent =
        daysTogether.toLocaleString();


      /* =========================================
         Life Progress
         ========================================= */

      const lifeExpectancy =
        18;


      const ageInYears =
        years +
        months / 12 +
        days / 365.25;


      let progress =
        (
          ageInYears /
          lifeExpectancy
        ) * 100;


      /* -----------------------------------------
         Keep Progress Between 0% and 100%
         ----------------------------------------- */

      progress =
        Math.min(
          Math.max(
            progress,
            0
          ),
          100
        );


      /* -----------------------------------------
         Update Percentage Text
         ----------------------------------------- */

      progressOutput.textContent =
        Math.round(progress) +
        "%";


      /* -----------------------------------------
         Update Progress Bar
         ----------------------------------------- */

      progressBar.style.width =
        progress +
        "%";


      /* =========================================
         Show Results
         ========================================= */

      results.hidden =
        false;


      /* -----------------------------------------
         Smooth Scroll to Results
         ----------------------------------------- */

      results.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    }
  );


  /* =========================================
     TABLE OF CONTENTS
     ========================================= */

  const tocLinks =
    document.querySelectorAll(
      "#cat-age-toc-nav a"
    );

  const sections =
    document.querySelectorAll(
      ".cat-age-article section"
    );


  if (
    !tocLinks.length ||
    !sections.length
  ) {
    return;
  }


  /* =========================================
     TOC Smooth Scroll
     ========================================= */

  tocLinks.forEach(function (link) {

    link.addEventListener(
      "click",
      function (event) {

        event.preventDefault();


        const targetId =
          this.getAttribute(
            "href"
          );


        const target =
          document.querySelector(
            targetId
          );


        if (!target) {
          return;
        }


        const headerOffset =
          110;


        const targetPosition =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset;


        window.scrollTo({

          top: targetPosition,

          behavior: "smooth"

        });

      }
    );

  });


  /* =========================================
     TOC Active Section
     ========================================= */

  const observer =
    new IntersectionObserver(

      function (entries) {

        entries.forEach(
          function (entry) {

            if (
              !entry.isIntersecting
            ) {
              return;
            }


            const id =
              entry.target.getAttribute(
                "id"
              );


            tocLinks.forEach(
              function (link) {

                link.classList.remove(
                  "active"
                );


                if (
                  link.getAttribute(
                    "href"
                  ) ===
                  "#" + id
                ) {

                  link.classList.add(
                    "active"
                  );

                }

              }
            );

          }
        );

      },

      {
        rootMargin:
          "-120px 0px -60% 0px"
      }

    );


  sections.forEach(
    function (section) {

      observer.observe(
        section
      );

    }
  );

});